<template>
  <b-modal
    ref="mssccs_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-0"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative p-[20px] pt-[28px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="icon-popup-warning"
        class="w-[100px] h-[100px] mx-auto mb-[24px]"
      >
      <h3 class="text-[18px] text-[#333333] font-semibold text-center">
        {{ title }}
      </h3>
      <p class="text-[#626262] text-[16px] font-normal text-center mb-[28px]">
        {{ message }}
      </p>
      <slot name="default" />
      <div class="flex items-center gap-[8px] mt-[16px]">
        <b-button
          block
          variant="primary"
          class="!flex items-center justify-center gap-[8px] mt-0"
          @click="hide"
        >
          Selesai
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>

/**
   * ModalSuccessChangeColdStorageFee
   * @description Success modal who will shown after the cold storage fee is changed or set
   * @returns {Object} ModalSuccessChangeColdStorageFee
   */
export default {
  name: 'ModalSuccessChangeColdStorageFee',
  data() {
    return {
      title: 'Perubahan Berhasil',
      message: 'Tarif Penyimpanan Cold Storage berhasil diajukan! Mohon ditunggu ya, tim Kompack sedang melakukan review!',
    }
  },
  methods: {
    /**
       * Show the modal success change cold storage fee, this function would be called by the parent component to show the modal
       * @param {Object} params - The parameters
       */
    show() {
      this.$refs.mssccs_kompack.show()
    },
    /**
       * Hide the modal success change cold storage fee
       */
    hide() {
      this.$refs.mssccs_kompack.hide()
    },
  },
}
</script>
